const IconPriceCeiling = () => (
    <svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.5 29.5L13.2228 32.8922C13.3936 32.9586 13.5871 32.9263 13.727 32.8079L19.6106 27.8295C19.8244 27.6486 20.1451 27.6785 20.3216 27.8959L25.9675 34.8446C26.2071 35.1396 26.6752 35.0699 26.8186 34.718L32 22M46.5 26.5L42.4808 28.2863C42.2193 28.4025 41.9138 28.276 41.8111 28.0089L39.5 22"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <path
            d="M39.5 22L35.9955 13.2386C35.8238 12.8096 35.2119 12.823 35.0593 13.2592L32 22"
            stroke="#FDC201"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <path
            d="M3 22H47"
            stroke="#FDC201"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="4 4"
        />
    </svg>
);

export default IconPriceCeiling;
